import { DummyReelSymbol, ReelInit, ReelObject } from "./ReelInit";

import { Group /*, Easing*/, Tween } from "tweedle.js";
import {
    getSymbol, /*, isLandingAnimationExist*/
    isIdleExist
} from "../config/getSymbol";


import { currentBackgorundMusic, currentBackgorundMusicVolume, getCurrentRoundBetDetails, isQuickBtnOnGlobal, isSlamClickedGlobal, isSuperQuickBtnOnGlobal, setIsSlamClickedGlobal } from "../config/GlobalVariableConfig";


import {
    REEL_NUMBERS,
    SYMBOL_HEIGHT,
    SYMBOLS_PER_REEL
} from "../config/reelConfig";
import { spinData } from "../server/getServerResposesFun";

import { IMediaInstance, sound } from "@pixi/sound";
import { Manager } from "../core/Manager";
import { SoundConstants } from "../gameClientEvents/SoundConstants";

const reelTweenGroup = new Group();

export class ReelSpin extends ReelInit {

    public running = false;
    public isBetDecline = false;

    private anticipationReels: number[];
    private movingSteps: number[];

    private reelSounds: (IMediaInstance | null)[] = [];

    private anticipationInSound: IMediaInstance | null = null;
    private anticipationLoopSound: IMediaInstance | null = null;

    private resetBackgoundVolume: boolean = false

    // private isFirstSpinFS: boolean = false;


    constructor() {
        super();

        this.movingSteps = [];

        this.setReelSpinSound();
        this.anticipationReels = [];

    }


    private setReelSpinSound(): void {
        this.reelSounds = new Array(REEL_NUMBERS).fill(null);
    }

    private playReelSound(reelIndex: number): void {
        if (reelIndex < 0 || reelIndex >= REEL_NUMBERS) return;

        // Stop old instance if exists
        this.reelSounds[reelIndex]?.stop();

        this.reelSounds[reelIndex] = sound.play(SoundConstants.REELS_SPIN, {
            loop: true,
            volume: 1 / REEL_NUMBERS,
        }) as IMediaInstance;
    }

    private stopReelSound(reelIndex: number): void {
        if (reelIndex < 0 || reelIndex >= REEL_NUMBERS) return;

        this.reelSounds[reelIndex]?.stop();
        this.reelSounds[reelIndex] = null;
    }

    private stopAllReelSounds(): void {
        for (let i = 0; i < REEL_NUMBERS; i++) {
            this.stopReelSound(i);
        }
    }

    public updateReelSpin(): void {

        Group.shared.update();
        reelTweenGroup.update();

    }

    private ismovingReelStepsCounted: boolean = false;

    public async startReels(RespinIndex: number, isNewSpin: boolean, spinStype: string): Promise<void> {
        try {

            console.log(`startReels this.running ${this.running}`);

            this.running = true;
            this.ismovingReelStepsCounted = false;
            this.resetBackgoundVolume = false;

            this.isBetDecline = false;
            setIsSlamClickedGlobal(false);

            // make container's symbols visible before spinning
            for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
                this.allReelArray[reelNum].container.visible = true;
            }

            if (isNewSpin) {
                this.resetReelOverlayContainer();
            }

            await this.reelSpinFun(RespinIndex, isNewSpin, spinStype);

        } catch (error: any) {
            console.log("inside catch of startPlay");
            throw (error);
        }

    }

    private getMovingSteps(RespinIndex: number, isNewSpin: boolean) {

        console.log("inside getMovingSteps");

        if (!isNewSpin) {
            this.movingSteps = [1, 1, 1, 1, 1];
            return;
        }

        let scatterAppear: number[] = [];

        spinData.respins[RespinIndex].reelSymbols.forEach(row => {
            let appearFlag = row.find(pos => pos === 12) ? 1 : 0;  // 12 is the scatter id
            scatterAppear.push(appearFlag);
        });


        const anticipationAfterGetting = 2;
        let scatterExist: number[] = [1, 1, 1, 1, 1]; // scatter appear on reels
        let ancipation: number[] = [];

        let sum = 0;
        scatterAppear.forEach((val, i) => {
            sum += val;

            if (sum - val >= anticipationAfterGetting && scatterExist[i] == 1) {
                ancipation.push(1);
            }
            else {
                ancipation.push(0);
            }

        })

        // console.log("ancipation", ancipation);
        this.anticipationReels = ancipation

        // this.movingSteps = [1, 2, 3, 4, 5];
        this.movingSteps = [1, 5, 10, 15, 20];

        // (initData.spinTime >= 5000 && this.spinStype === "BASE") ?
        //     [1, 3, 5, 7, 9]
        //     :
        //     [1, 2, 3, 4, 5]
        // ;

        // this.movingSteps = [1, 5, 9, 13, 17];//[1, 2, 3, 4, 5];
        let additionalSteps = 0;
        for (let i = 0; i < this.movingSteps.length; i++) {
            if (ancipation[i] === 1 && !getCurrentRoundBetDetails().bonusBuy) {
                additionalSteps += 45;
            }
            this.movingSteps[i] += additionalSteps; // Add extra anticipation-based steps
        }

        // if (spinStype === "FREEGAME" && this.isFirstSpinFS === false) {
        //     const extraSteps = 30;
        //     this.movingSteps = this.movingSteps.map((steps) => steps + extraSteps);
        //     this.isFirstSpinFS = true;
        // }

        console.log("this.movingSteps", this.movingSteps);
        // return ancipation;

        // return [0, 0, 0, 0, 0]

    }

    private async landingAnimation(reelNum: number): Promise<void> {

        const timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

        const animationPromises: Promise<void>[] = [];

        let scatterLanded = false;
        for (let j = 0; j < SYMBOLS_PER_REEL; j++) {

            const posNum = j;

            const symbol = this.reelSymbols[reelNum][posNum];

            const symbolId = this.allReelArray[reelNum].symbols[posNum].id;

            if (symbolId == 12) {
                scatterLanded = true;
            }
            if (symbolId == 13) {
                sound.play(SoundConstants.RIP_SYMBOL, { volume: 1 });
            }
            
            const animationPromise = new Promise<void>((resolve) => {
                let listener = {
                    complete: () => {
                        resolve();
                        symbol.state.removeListener(listener);
                        if (isIdleExist(symbolId)) {
                            symbol.state.setAnimation(0, "idle", true);
                        }
                    }
                };
                symbol.state.addListener(listener);
                
                symbol.state.setAnimation(0, "land", false);
                symbol.state.timeScale = timeScale;
            })
            animationPromises.push(animationPromise);
            
            
        }
        
        
        if (scatterLanded) {
            sound.play(SoundConstants.SCATTER_LAND, { volume: 1, speed: timeScale });
            sound.play(SoundConstants.SCATTER_LANDED,{ volume: 1 });
        }
        else {
            sound.play(SoundConstants.REEL_STOP, { volume: 1, speed: timeScale });
        }

        await Promise.all(animationPromises);
        this.stopAnticipationSound();


    }



    private async reelSpinFun(RespinIndex: number, isNewSpin: boolean, spinStype: string): Promise<void> {

        console.log("reelSpinFun", isNewSpin, spinStype);

        const promises: Promise<void>[] = [];

        // Loop over each reel object in the allReelArray

        this.allReelArray.forEach((reelObj, index) => {
            // Create a promise that chains multiple moveReel calls based on the index
            const promise = new Promise<void>(async (resolve) => {

                this.playReelSound(index);

                while (!spinData.dataFeatched && !this.isBetDecline) {
                    const dummySymbolId = this.getNextRandomSymbol(reelObj.reelIndex);
                    this.swapTopSymbol(reelObj, dummySymbolId);
                    await this.moveReelStep(reelObj);

                    if (this.isBetDecline) {
                        this.stopAllReelSounds();
                    }
                }

                if (!this.isBetDecline) {

                    if (!this.ismovingReelStepsCounted) {
                        this.getMovingSteps(RespinIndex, isNewSpin);
                        this.ismovingReelStepsCounted = true;
                    }

                    let i = 0;
                    while (i < this.movingSteps[index]) {

                        if ((isSuperQuickBtnOnGlobal || isQuickBtnOnGlobal || isSlamClickedGlobal || this.isBetDecline)) {
                            break;
                        }

                        const dummySymbolId = this.getNextRandomSymbol(reelObj.reelIndex);
                        this.swapTopSymbol(reelObj, dummySymbolId);
                        await this.moveReelStep(reelObj);
                        i++;
                    }

                }

                await this.moveReelFinal(reelObj, RespinIndex);

                this.stopReelSound(index);

                this.addReelSymbolsToContainer(index);
                await this.landingAnimation(index);

                this.playAnticipation(index);
                resolve();

            });

            promises.push(promise);

        });

        await Promise.all(promises);
        sound.stop(SoundConstants.REELS_SPIN);

        await this.allReelStop();

        if (this.isBetDecline) { // if bet is decline no need to go further for battleTrigger
            return;
        }

        if (isNewSpin && spinStype === "BASE") {
            Manager.casinoChannelHandler.reportResultDisplay();
        }

        if (spinStype === "BASE" && spinData.respins[RespinIndex].winAmount == 0) {
            // in this case no cat jump is required
        }
        else {

        }


        this.running = false;

    }

    private dummyReelSymbolQueues: number[][] = [];
    private getNextRandomSymbol(reelNum: number): number {
        // Initialize queue if not yet
        if (!this.dummyReelSymbolQueues[reelNum]) {
            this.dummyReelSymbolQueues[reelNum] = [];
        }

        // If queue is empty, refill it
        if (this.dummyReelSymbolQueues[reelNum].length === 0) {
            const reelData = DummyReelSymbol[reelNum];
            const maxStartIndex = reelData.length - SYMBOLS_PER_REEL;
            const randomStart = Math.floor(Math.random() * maxStartIndex);
            const newSlice = reelData.slice(randomStart, randomStart + SYMBOLS_PER_REEL);

            this.dummyReelSymbolQueues[reelNum].push(...newSlice);
        }

        // Pop the next symbol from the queue
        const dummyReelSymbol = this.dummyReelSymbolQueues[reelNum].shift();
        return dummyReelSymbol;
    }

    private stopAnticipationSound(): void {
        this.anticipationInSound?.stop();
        this.anticipationInSound = null;

        this.anticipationLoopSound?.stop();
        this.anticipationLoopSound = null;

    }



    private playAnticipation(i: number): void {

        let currentBetDetails = getCurrentRoundBetDetails();
        if (!currentBetDetails.bonusBuy) {
            // Clear previous visuals & audio
            this.stopAnticipationSound();


            this.anticipation[i].visible = false;
            this.anticipation[i].state.clearTrack(0);

            if (i < REEL_NUMBERS - 1 && this.anticipationReels[i + 1] === 1) {

                if (currentBackgorundMusic && !this.resetBackgoundVolume) {
                    currentBackgorundMusic.volume = 0.3;
                    this.resetBackgoundVolume = true;
                }

                this.anticipation[i + 1].visible = true;
                this.anticipation[i + 1].state.setAnimation(0, "animation", true);


                this.anticipationInSound = sound.play(SoundConstants.ANTICIPATION_LOOP, {
                    loop: true,
                    volume: 1
                }) as IMediaInstance;

            }
        }

    }


    private async moveReelFinal(reelObj: ReelObject, RespinIndex: number): Promise<void> {
        return new Promise(async (resolve) => {
            const reelNum = reelObj.reelIndex;

            let finalReelData: number[];

            if (!this.isBetDecline) {
                finalReelData = spinData.respins[RespinIndex].reelSymbols[reelNum];
            }
            else {
                finalReelData = this.reelSymbolsBeforeSpin[reelNum];
            }

            // console.log("finalReelData", finalReelData);

            for (let i = 0; i < finalReelData.length; i++) {
                const symbolId = finalReelData[finalReelData.length - 1 - i];

                // console.log("finalReelData symbolId", symbolId);

                this.swapTopSymbol(reelObj, symbolId);
                await this.moveReelStep(reelObj);

                if (i == finalReelData.length - 1) {
                    this.reArrangeTheSymbolOrder(reelObj);
                }
            }

            resolve();
        });
    }

    private swapTopSymbol(reelObj: ReelObject, symbolId: number) {
        const topSymbol = reelObj.symbols[SYMBOLS_PER_REEL];
        topSymbol.id = symbolId;
        topSymbol.symbol.texture = getSymbol(symbolId);
    }

    private reArrangeTheSymbolOrder(reelObj: ReelObject) {
        // // Re-add them in correct order (important for rendering layer)
        reelObj.symbols.forEach((s) => {
            reelObj.container.addChild(s.view);
        });
    }


    private async moveReelStep(reelObj: ReelObject): Promise<void> {

        const movetime = isSuperQuickBtnOnGlobal ? 10 : (isQuickBtnOnGlobal ? 20 : 40);

        return new Promise((resolve) => {
            const totalSymbols = reelObj.symbols.length;
            let completed = 0;

            // Move each symbol visually
            reelObj.symbols.forEach((symbol) => {
                const symbolContainer = symbol.view;

                const tween = new Tween(symbolContainer, reelTweenGroup)
                    .to({ y: symbolContainer.y + SYMBOL_HEIGHT }, movetime)
                    .onComplete(() => {
                        reelTweenGroup.remove(tween);
                        completed++;

                        // Once all tweens complete
                        if (completed === totalSymbols) {

                            // Move last symbol visually to top
                            const movedSymbol = reelObj.symbols.pop();
                            if (movedSymbol) {
                                movedSymbol.view.y = - (SYMBOL_HEIGHT / 2);
                                movedSymbol.y = movedSymbol.view.y;
                                reelObj.symbols.unshift(movedSymbol);
                            }

                            // Update symbolIndex and view.y of all symbols
                            reelObj.symbols.forEach((s, i) => {
                                s.symbolIndex = i;
                                s.view.y = i === SYMBOLS_PER_REEL
                                    ? - (SYMBOL_HEIGHT / 2)
                                    : (SYMBOL_HEIGHT / 2) + i * SYMBOL_HEIGHT;
                                s.y = s.view.y;
                            });


                            resolve();
                        }
                    })
                    .start();
            });
        });
    }

    public resetSymbolPositions() {

        this.allReelArray.forEach((reelObj) => {

            reelObj.symbols.forEach((symbol) => {
                const targetPos = symbol.y;
                const symbolContainer = symbol.view;
                symbolContainer.y = targetPos;

            })

        })
    }


    private async allReelStop() {
        if (this.resetBackgoundVolume && currentBackgorundMusic) {
            currentBackgorundMusic.volume = currentBackgorundMusicVolume;
        }

        console.log("reel spin done");

    }


}
